import * as yup from "yup";

export const schema = yup.object().shape({
  name: yup.string().required("Поле Имя обязательно для заполнения"),
  status: yup
    .object()
    .nullable()
    .required("Поле Статус обязательно для заполнения"),
});
